import * as React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  required,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles({
  inline: {
      display: 'inline-block',
      marginLeft: '1em',
      '&.first-child': {
          marginLeft: 0,
      },
  },
});

const QuizEdit = (props) => {
  const classes = useStyles();

  return (
    <Edit title="Editar Pergunta" {...props} >
      <SimpleForm>
        <TextInput label="Nome genérico (pergunta)" source="raw_name" disabled={true} />
        <TextInput label='Pontuação' source='question_point'/>

        <TextInput label="Pergunta (pt-BR)" source="ptbr_name" validate={required()} formClassName={clsx(classes.inline, 'first-child')} />
        <TextInput label="Pergunta (en-US)" source="enus_name" validate={required()} formClassName={classes.inline} />
        <TextInput label="Pergunta (es-ES)" source="es_name" validate={required()} formClassName={classes.inline} />
        {/* <TextInput label="Pergunta (hu-HU)" source="hu_name" validate={required()} formClassName={classes.inline} /> */}
        <div></div>

        <ArrayInput source="options">
            <SimpleFormIterator>
              <BooleanInput label="Está correta" source="is_correct" />
              <TextInput label="Nome genérico (option)" source="raw_name" disabled={true} />
              <TextInput label="Pergunta (pt-BR)" source="ptbr_name" validate={required()} />
              <TextInput label="Pergunta (en-US)" source="enus_name" validate={required()} />
              <TextInput label="Pergunta (es-ES)" source="es_name" validate={required()} />
              {/* <TextInput label="Pergunta (hu-HU)" source="hu_name" validate={required()} /> */}
            </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
}

export default QuizEdit;
